import { GraphNodeTypePopper } from "@features/graph/GraphNodeTypePopper"
import { NodeSearchPopper } from "@features/graph/NodeSearchPopper"
import { KeyBinding } from "@features/keymap/KeyBinding"
import { shortcuts } from "@features/keymap/shortcuts"
import { useKeymap } from "@features/keymap/useKeymap"
import { Box, Button, Popper } from "@mui/material"
import { ReactNode, useRef, useState } from "react"

type GraphActionsProps = {
  showExpandAllButton: boolean
  showResetGraphButton: boolean
  showExportGraphButton: boolean
  showAddToSelection: boolean
  showNodeTypesButton: boolean
  onExpandAllClick: () => void
  onResetGraphClick: () => void
  onExportGraphClick: () => void
  children: ReactNode
}

const GraphActions = (props: GraphActionsProps) => {
  const searchButtonRef = useRef<HTMLButtonElement>(null)
  const nodeTypesbuttonRef = useRef<HTMLButtonElement>(null)

  const [isSearchVisible, setIsSearchVisible] = useState(false)
  const [isNodeTypesOpen, setNodeTypesOpen] = useState(false)

  const { getKeymaps } = useKeymap()
  const keymap = getKeymaps().byId

  return (
    <Box sx={{ mb: "2px" }}>
      <KeyBinding
        bind={shortcuts["toggle-search"]}
        onKeyDown={() => setIsSearchVisible((prev) => !prev)}
      />
      <Button
        variant="outlined"
        color="error"
        sx={{ ml: 0, p: "2px", pl: "8px", pr: "8px" }}
        ref={searchButtonRef}
        onClick={() => setIsSearchVisible((prev) => !prev)}
        title={keymap.get("toggle-search")?.desc}
      >
        SEARCH
      </Button>
      <Popper open={isSearchVisible} anchorEl={searchButtonRef.current} placement="bottom-start">
        <Box>
          <NodeSearchPopper
            onCloseClick={() => setIsSearchVisible(false)}
            showAddToSelection={props.showAddToSelection}
          />
        </Box>
      </Popper>
      {props.showExpandAllButton && (
        <>
          <KeyBinding bind={shortcuts["expand-all-groups"]} onKeyDown={props.onExpandAllClick} />
          <Button
            variant="outlined"
            color="error"
            sx={{ ml: 1, p: "2px", pl: "8px", pr: "8px" }}
            onClick={props.onExpandAllClick}
            title={keymap.get("expand-all-groups")?.desc}
          >
            EXPAND ALL
          </Button>
        </>
      )}
      {props.showResetGraphButton && (
        <Button
          variant="outlined"
          color="error"
          sx={{ ml: 1, p: "2px", pl: "8px", pr: "8px" }}
          onClick={props.onResetGraphClick}
        >
          RESET GRAPH
        </Button>
      )}
      {props.showExportGraphButton && (
        <Button
          variant="outlined"
          color="error"
          sx={{ ml: 1, p: "2px", pl: "8px", pr: "8px" }}
          onClick={props.onExportGraphClick}
        >
          EXPORT GRAPH
        </Button>
      )}
      {props.showNodeTypesButton && (
        <Button
          variant="outlined"
          color="error"
          sx={{ ml: 1, p: "2px", pl: "8px", pr: "8px" }}
          ref={nodeTypesbuttonRef}
          onClick={() => setNodeTypesOpen((value) => !value)}
        >
          NODE TYPES
        </Button>
      )}
      <Popper open={isNodeTypesOpen} anchorEl={nodeTypesbuttonRef.current} placement="bottom-start">
        <Box>
          <GraphNodeTypePopper onCloseClick={() => setNodeTypesOpen(false)} />
        </Box>
      </Popper>
      {props.children}
    </Box>
  )
}

export default GraphActions
